<template>
  <Drawer
    :transfer="true"
    title="审批人设置"
    v-model="visible"
    placement="right"
    class="set_promoter"
    width="550px"
    :closable="false"
    :before-close="closeDrawer"
  >
    <div class="demo-drawer__content">
      <div class="drawer_content">
        <!-- 选择审批类型 -->
        <RadioGroup v-model="approverConfig.auditType" @on-change="auditChange">
          <Radio :label="1">人工审批</Radio>
          <Radio :label="2">自动通过</Radio>
          <Radio :label="3">自动拒绝</Radio>
        </RadioGroup>
        <div v-if="approverConfig.auditType == 1">
          <!-- 当为人工审批时，展示下面的东西，复杂逻辑 -->
          <!-- 首先是一个tabs -->
          <Tabs name="approverTab" style="margin-top: 10px">
            <TabPane
              label="设置审批人"
              name="approverSetting"
              tab="approverTab"
            >
              <dealwithInfo
                ref="dealwithInfoRef"
                v-if="visible"
                :dataConfig.sync="approverConfig"
                typeTitle="审批人"
              />
            </TabPane>
            <TabPane
              label="表单操作权限"
              name="approverPermission"
              tab="approverTab"
            >
              <permissionInfo
                v-if="visible"
                ref="permissionInfoRef"
                :dataConfig="approverConfig"
                :formOpAuthList="approverConfig.formOpAuthList"
              />
            </TabPane>
          </Tabs>
        </div>
      </div>
    </div>
    <div class="demo-drawer__footer clear">
      <Button @click="closeDrawer">取 消</Button>
      <Button type="primary" @click="saveApprover">确 定</Button>
    </div>
  </Drawer>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { permissionInfo, dealwithInfo } from '../drawerInfo';
import preload from '../../plugins/preload';
import { getAllUserByDepartment } from '@/api/workflow';
import { userTypeConfig } from './drawerConfig';
export default {
  components: { dealwithInfo, permissionInfo },
  props: ['directorMaxLevel'],
  data() {
    return {
      approverConfig: {},
      visible: false
    };
  },
  computed: {
    ...mapState('workflow', ['approverConfig1', 'approverDrawer'])
  },
  watch: {
    approverDrawer(value) {
      this.visible = value;
    },
    approverConfig1(val) {
      this.approverConfig = val.value;
    }
  },
  methods: {
    ...mapMutations('workflow', ['setApproverConfig', 'setApprover']),
    async saveApprover() {
      const { auditType, userType, userNullProcType } = this.approverConfig;
      if (auditType != 1) {
        // 如果是自动审核或者自动拒绝  即 非人工审批时候，要把对应的置为空
        this.approverConfig.userType = ''; // 发起人类型
        this.approverConfig.nodeExecUsers = []; // 人员id为空
        this.approverConfig.nodeUserList = []; // 人员为空
        this.approverConfig.execType = ''; // 审批顺序置为空
        this.approverConfig.userNullProcType = ''; // 审批人为空时处理方式置为空
      }
      // 如果是人工处理 并且是指定人员｜指定部门｜指定角色时 保存对应选择的人员
      if (auditType == 1 && ![4, 5].includes(userType)) {
        const { listName } = userTypeConfig[userType];
        const dealwithInfoDom = this.$refs.dealwithInfoRef;
        const { list } = dealwithInfoDom;
        const nodeUserList = list[listName];
        this.approverConfig.nodeUserList = nodeUserList;
        // 如果是人工审批时，并且nodeUserList 只选择一个人的话，默认给审批类型为依次审批
        if (userType == 1 && nodeUserList.length == 1) {
          this.approverConfig.execType = 1;
        }
        this.approverConfig.nodeExecUsers = nodeUserList.map(i => {
          // 当是部门的时候，后端要 relationId
          return userType == 2 ? i.relationId : i.id;
        });
      }
      // 如果选择的是部门的话，调用接口获取当前部门下的人数
      if (
        auditType == 1 &&
        userType == 2 &&
        this.approverConfig.nodeUserList.length > 0
      ) {
        const { nodeUserList } = this.approverConfig;
        const ids = nodeUserList.map(i => i.id).join(',');
        const res = await getAllUserByDepartment(ids);
        const { code, data } = res.data;
        if (code == 200) {
          this.approverConfig.departmentPersonNum = data.length;
        }
      }
      // 如果是人工处理 并且不是指定人员时设置指定人员
      if (auditType == 1 && userType != 1 && userNullProcType == 3) {
        const dealwithInfoDom = this.$refs.dealwithInfoRef;
        const { userNullSelUserList = [] } = dealwithInfoDom;
        if (userNullSelUserList.length < 1) {
          this.$Message.error('指定人员不能为空');
          return;
        }
        this.approverConfig.userNullSelUserList = userNullSelUserList;
        this.approverConfig.userNullSelUserId = (
          userNullSelUserList[0] || {}
        ).id;
      } else {
        this.approverConfig.userNullSelUserList = [];
        this.approverConfig.userNullSelUserId = '';
      }
      if (auditType == 1) {
        const permissionInfoDom = this.$refs.permissionInfoRef;
        const formOpAuthList = permissionInfoDom.getFormOpAuthListData();
        this.approverConfig.formOpAuthList = formOpAuthList;
      }
      this.approverConfig.error = !preload.setApproverStr(this.approverConfig);
      this.setApproverConfig({
        value: this.approverConfig,
        flag: true,
        id: this.approverConfig1.id
      });
      this.$emit('update:nodeConfig', this.approverConfig);
      this.closeDrawer();
    },
    closeDrawer() {
      this.setApprover(false);
    },
    auditChange(value) {
      if (value == 1) {
        this.approverConfig.userType = 1;
        this.approverConfig.execType = 1;
      }
    }
  }
};
</script>
<style lang="less">
.set_promoter {
  .approver_content {
    padding-bottom: 10px;
    border-bottom: 1px solid #f2f2f2;
  }

  .approver_self_select .Button,
  .approver_content .Button {
    margin-bottom: 20px;
  }

  .approver_content .Radio,
  .approver_some .Radio,
  .approver_self_select .Radio {
    width: 27%;
    margin-bottom: 20px;
  }

  .approver_manager p {
    line-height: 32px;
  }

  .approver_manager select {
    width: 420px;
    height: 32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(217, 217, 217, 1);
  }

  .approver_manager p.tip {
    margin: 10px 0 22px 0;
    font-size: 12px;
    line-height: 16px;
    color: #f8642d;
  }

  .approver_self {
    padding: 28px 20px;
  }

  .approver_self_select,
  .approver_manager,
  .approver_content,
  .approver_some {
    padding: 20px 20px 0;
  }

  .approver_manager p:first-of-type,
  .approver_some p {
    line-height: 19px;
    font-size: 14px;
    margin-bottom: 14px;
  }

  .approver_self_select h3 {
    margin: 5px 0 20px;
    font-size: 14px;
    font-weight: bold;
    line-height: 19px;
  }
}
</style>
